import React from 'react';
import { Info } from 'lucide-react';

export default function DemoNotice({ compact = false, className = '' }) {
  if (compact) {
    return (
      <div className={`flex items-start gap-2 text-xs text-slate-600 bg-amber-50 border border-amber-200 rounded-md px-3 py-2 ${className}`}>
        <Info className="w-3.5 h-3.5 mt-0.5 text-amber-600 shrink-0" />
        <span><span className="font-semibold text-slate-800">Demo results:</span> Prices and availability shown are for demonstration purposes while we integrate our travel partners. Live pricing and availability will be provided once partner integrations are activated.</span>
      </div>
    );
  }
  return null;
}
